import Cookies from "js-cookie";
import { IUser } from "../types/UserData";
import { userGQLSchema } from "./gql/User";
import { gqlRequest } from "./functions";
import { USERS_URL } from "./env";
export const setAuthentication = (token: string, remember?: boolean) =>
  remember
    ? Cookies.set("SyriaONEauthToken", token, { expires: 356 })
    : Cookies.set("SyriaONEauthToken", token, { expires: 1 });
export const getAuthentication = () => {
  const token = Cookies.get("SyriaONEauthToken");
  return token || null;
};
export const removeAuthentication = () => Cookies.remove("SyriaONEauthToken");

export const getUserData = async (token: string): Promise<IUser | null> => {
  const gqlString = `query {
    GetUserData {
      ${userGQLSchema}
    }
  }`;

  try {
    const response = await gqlRequest<{ GetUserData: IUser }>({
      query: gqlString,
      endpoint: USERS_URL,
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    if (response.errors && response.errors.length > 0) {
      return null;
    }

    return response.data?.GetUserData || null;
  } catch (err: unknown) {
    throw err;
  }
};
